var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-breadcrumb',{key:_vm.crumbs.length,attrs:{"items":_vm.crumbs,"auto-resize":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }